// 根据前缀，走MOCK、代理、及线上
// 为空走MOCK，不为空，根据实际情走代理及线上，代理配置在build/dev-server.js。
// const prefix = 'http://192.168.0.105:9090/server';
// const prefix = 'http://czys.cj-edu.com/server';
// const prefix = 'http://czvtc.cj-edu.com/server';
// const prefix = 'http://hbsi.cj-edu.com/server';
// const prefix = 'http://bhlgxy.cj-edu.com/server';
// const prefix = 'http://hbkjxy.cj-edu.com/server';
// const prefix = 'http://jjykt.cj-edu.com/server';
const prefix = window.configs.API_ROOT;
const jwlApis = {
    BASEURL: prefix,
    DEBUG: false,
    LOGIN: {
        passwordLogin: `${prefix}/login.do`, //学生登录
        getNowTime: `${prefix}/getNowTime.do`, //获取系统时间
    },
    UPLOAD: `${prefix}/api/file/update.do`,
    UPLOAD_64: `${prefix}/api/file/uploadBase64.do`,
    INDEX: {
        getHomePageInfo: `${prefix}/api/student/getHomePageInfo.do`, //获取学生端首页数据
    },
    COMMON: {
        savetocart: `${prefix}/microWeb/shoppingCart/saveToCart.do`,
    },
    USER: {
        logout: `${prefix}/logout.do`, //学生退出
        getStudentInfo: `${prefix}/api/student/getStudentInfo.do`, //获取学生信息
        uploadStudentNewData: `${prefix}/api/student/uploadStudentNewData.do`, //上传报道材料（审核不通过后的重新上传也是这个）
        getStudentNewData: `${prefix}/api/student/getStudentNewData.do`, //查询已上传的报道材料（已审核的话就没办法修改了）
        getSemester: `${prefix}/api/student/getSemester.do`, //学期数
        getTeachingPlanCourse: `${prefix}/api/student/getTeachingPlanCourse.do`, //教学计划(两个都查这个)
        getElectiveCourse: `${prefix}/api/student/getElectiveCourse.do`, //选课中心 列表（全部）
        getSelectedElectiveCourse: `${prefix}/api/student/getSelectedElectiveCourse.do`, //选课中心 列表（已选）
        electiveCourse: `${prefix}/api/student/electiveCourse.do`, //选课中心 选课
        delElectiveCourse: `${prefix}/api/student/delElectiveCourse.do`, //选课中心 退课
        getElectivesList: `${prefix}/api/student/getElectivesList.do`, //选课中心 选修课列表【新】
        joinElective: `${prefix}/api/student/joinElective.do`, //选课中心 加入选修课【新】
        getLeaningCenterList: `${prefix}/api/student/getLeaningCenterList.do`, //学习中心 列表
        getLeaning: `${prefix}/api/student/getLeaning.do`, //学习中心 学习
        getLeaningLog: `${prefix}/api/student/getLeaningLog.do`, //学习中心 学习 学习记录
        leaning: `${prefix}/api/student/leaning.do`, //学习中心 学习 开始学习
        getFaceSetting: `${prefix}/jlw/faceSetting/list.json`,//学习中心 学习 获取当前课程的全部人脸识别权限
        getHomeworkList: `${prefix}/api/student/getHomeworkList.do`, //学习中心 作业 列表
        getHomeworkInfo: `${prefix}/api/student/getHomeworkInfo.do`, //学习中心 作业 开始作业
        answerHomework: `${prefix}/api/student/answerHomework.do`, //学习中心 作业 答题
        handHomework: `${prefix}/api/student/handHomework.do`, //学习中心 作业 交卷
        getHomeworkLog: `${prefix}/api/student/getHomeworkLog.do`, //学习中心 作业记录
        getHomeworkStudentInfo: `${prefix}/api/student/getHomeworkStudentInfo.do`, //学习中心 作业记录 查看答卷
        continueHomeworkInfo: `${prefix}/api/student/continueHomeworkInfo.do`, //学习中心 作业记录 继续作业
        getExamList: `${prefix}/api/student/getExamList.do`, //学习中心 考试 列表
        getExamInfo: `${prefix}/api/student/getExamInfo.do`, //学习中心 考试 开始考试
        answerExam: `${prefix}/api/student/answerExam.do`, //学习中心 考试 答题
        handExam: `${prefix}/api/student/handExam.do`, //学习中心 考试 交卷
        getExamLog: `${prefix}/api/student/getExamLog.do`, //学习中心 考试 考试记录
        getExamStudentInfo: `${prefix}/api/student/getExamStudentInfo.do`, //学习中心 考试记录 查看答卷
        wrongQuestionQuery: `${prefix}/api/student/wrongQuestionQuery.do`, //学习中心 错题本 按作业模块练习（列表 传homeworkStudentId）
        wrongQuestionInfo: `${prefix}/api/student/wrongQuestionInfo.do`, //学习中心 错题本 练习、直接练习 (不传homeworkStudentId)
        deleteWrongQuestion: `${prefix}/api/student/deleteWrongQuestion.do`, //学习中心 错题本 删除
        getLeavingMessageQuery: `${prefix}/api/student/getLeavingMessageQuery.do`, //学习中心 答疑 列表
        addLeavingMessage: `${prefix}/api/student/addLeavingMessage.do`, //学习中心 答疑 提问
        tackedOnLeavingMessage: `${prefix}/api/student/tackedOnLeavingMessage.do`, //学习中心 答疑 讨论（就是在答疑下面加话）
        deleteLeavingMessage: `${prefix}/api/student/deleteLeavingMessage.do`, //学习中心 答疑 删除 提问或讨论
        editLike: `${prefix}/api/student/editLike.do`, //学习中心 答疑 点赞（重复点就是取消）
        collection: `${prefix}/api/student/collection.do`, //学习中心 答疑 收藏（重复点就是取消）
        getCourseResourceList: `${prefix}/api/student/getCourseResourceList.do`, //资料下载 列表
        downloadFeedback: `${prefix}/api/student/downloadFeedback.do`, //资料下载 列表 点击下载后的反馈
        getPersonalInfo: `${prefix}/api/student/getPersonalInfo.do`, //学生信息 个人信息 查看
        editPersonalInfo: `${prefix}/api/student/editPersonalInfo.do`, //学生信息 个人信息 修改
        getStudentStatusPhoto: `${prefix}/api/student/getStudentStatusPhoto.do`, //学生信息 学籍照片查询 审核通过的就不能修改了
        addStudentStatusPhoto: `${prefix}/api/student/addStudentStatusPhoto.do`, //学生信息 学籍照片上传
        getStudentGraduationPhoto: `${prefix}/api/student/getStudentGraduationPhoto.do`, //学生信息 毕业照片查询 审核通过的就不能修改了
        addStudentGraduationPhoto: `${prefix}/api/student/addStudentGraduationPhoto.do`, //学生信息 毕业照片上传
        getMyMessageList: `${prefix}/api/student/getMyMessageList.do`, //学生信息 我的消息 列表
        setAllAcceptState: `${prefix}/api/student/setAllAcceptState.do`, //学生信息 我的消息 一键已读
        getMyMessageInfo: `${prefix}/api/student/getMyMessageInfo.do`, //学生信息 我的消息 查看详情
        editPassword: `${prefix}/api/student/editPassword.do`, //学生信息 我的消息 查看详情
        getNoticeList: `${prefix}/api/student/getNoticeList.do`, //通知公告 列表
        getNoticeInfo: `${prefix}/api/student/getNoticeInfo.do`, //通知公告 详情
        getMyMessageNum: `${prefix}/api/student/getMyMessageNum.do`, //获取未读通知
        confirmStudentStatusPhoto: `${prefix}/api/student/confirmStudentStatusPhoto.do`, //学生信息 学籍照片确认
        confirmStudentGraduationPhoto: `${prefix}/api/student/confirmStudentGraduationPhoto.do`, //学生信息 毕业照片确认
        acceptData: `${prefix}/videos/acceptData.do`, //提交视频记录
        getM3U8List: `${prefix}/workoutVideos/getM3U8List.do`, //获取视频分段
        saveVideosLog: `${prefix}/workoutVideos/saveVideosLog.do`, //提交视频记录信息
        newSaveVideosLog: `${prefix}/workoutVideos/newSaveVideosLog.do`, //提交视频记录信息【新的保存方法】
        getGrades: `${prefix}/api/student/getGrades.do`, //成绩查询
        getAchievementItemTableHeader: `${prefix}/api/student/getAchievementItemTableHeader.do`, //动态表头
        getMakeUpExamList: `${prefix}/api/student/getMakeUpExamList.do`, //动态表头
        getStudentNewInfo: `${prefix}/api/student/getStudentNewInfo.do`, //获取新生信息
        confirmStudentNewInfo: `${prefix}/api/student/confirmStudentNewInfo.do`, //学生报道 1:已报到，2:未确认
        useImgTemplate: `${prefix}/api/student/useImgTemplate.do`, //获取学生录取通知书信息
        useTableTemplate: `${prefix}/api/student/useTableTemplate.do`, //获取学生表格模板
        exportTableTemplateToPdf: `${prefix}/api/student/exportTableTemplateToPdf.do`, //导出学籍卡
        queryMakeUpExam: `${prefix}/api/student/queryMakeUpExam.do`,//补考列表
        getMakeUpExamLog: `${prefix}/api/student/getMakeUpExamLog.do`,//补考记录列表
        saveCompensateVideosLog: `${prefix}/api/workoutVideos/saveCompensateVideosLog.do`,//播放完成提交
        getClientNeedStudyLog: `${prefix}/api/student/getClientNeedStudyLog.do`,//同步课程记录
        compensateVideoLog: `${prefix}/api/student/compensateVideoLog.do`,//同步请求
        face: `${prefix}/api/student/face.do`,//人脸识别
        face_record: `${prefix}/jlw/facePhotoRecords/add.json`,//新增人脸识别详细记录（人脸识别结束之后调用）
        getDissertation: `${prefix}/api/student/getDissertation.do`,//人脸识别
        updateDissertationUrl: `${prefix}/api/student/updateDissertationUrl.do`,//人脸识别
        getMessageAccept: `${prefix}/api/student/getMessageAccept.do`,//获取最新未读消息 直接提示

        getCanEditTemplateSingle: `${prefix}/api/student/getCanEditTemplateSingle.do`,//获取可编辑模板
        getEditStatusChangeTemplate: `${prefix}/api/student/getEditStatusChangeTemplate.do`,//获取可编辑模板
        saveEditTemplateData: `${prefix}/api/student/saveEditTemplateData.do`,//保存模板信息
        getAttrTreeById: `${prefix}/api/student/getAttrTreeById.do`,//根据模板ID获取树结构值
        getTemplateByName: `${prefix}/api/student/getTemplateByName.do`,//获取模板信息
        getTemplateById: `${prefix}/api/student/getTemplateById.do`,//获取模板信息 id

        updateVideoLog: `${prefix}/api/student/updateVideoLog.do`,//获取模板信息

        getLivePlanList: `${prefix}/api/livePlan/getLivePlanList.do`, //直播 列表
        saveLiveWork: `${prefix}/api/liveWork/add.do`, //保存作业url提交
        updateLiveWork: `${prefix}/api/liveWork/edit.do`, //编辑作业url提交

        getSurveyList: `${prefix}/api/student/getSurveyList.do`, //问卷列表
        getSurveyMessageNum: `${prefix}/api/student/getSurveyMessageNum.do`, //未填写的问卷数量
        getTeacherEvaluateList: `${prefix}/api/student/getTeacherEvaluateList.do`, //教师评价列表
        getTeacherEvaluate: `${prefix}/api/student/getTeacherEvaluate.do`, //获取教师评价信息
        saveTeacherEvaluate: `${prefix}/api/student/saveTeacherEvaluate.do`, //保存教师评价
        getTeaEvaluateMessageNum: `${prefix}/api/student/getTeaEvaluateMessageNum.do`, //未填写的教师评价数量

        /**
         * 新生报到
         */
        getStuNewVerifyPhoneOpenConfig: `${prefix}/api/student/getStuNewVerifyPhoneOpenConfig.do`, //是否开启手机验证
        getStudentVerifyData: `${prefix}/api/student/getStudentVerifyData.do`, //获取学生手机号校验数据
        getVerifyStudentPhoneNeedSendSms: `${prefix}/api/student/getVerifyStudentPhoneNeedSendSms.do`, //是否需要填写验证码才能确定
        getVerifyCodeIntervalTime: `${prefix}/api/student/getVerifyCodeIntervalTime.do`, //获取短信验证码发送冷却时间
        sendVerifyCode: `${prefix}/api/student/sendVerifyCode.do`, //发送验证码
        verifyStudentPhone: `${prefix}/api/student/verifyStudentPhone.do`, //校验手机验证码
        getStudentReportShowConfig: `${prefix}/api/student/getStudentReportShowConfig.do`, //新生报到菜单是否显示
        getStudentReportFlowConfig: `${prefix}/api/student/getStudentReportFlowConfig.do`, //获取新生报道各个流程的开关配置
        getStudentPayStatus: `${prefix}/api/student/getStudentPayStatus.do`, //获取缴费状态
        getPayAmount: `${prefix}/api/student/getPayAmount.do`, //显示缴费金额
        getStudentNewPhoto: `${prefix}/api/student/getStudentNewPhoto.do`, //获取学籍照片信息
        addStudentNewPhoto: `${prefix}/api/student/addStudentNewPhoto.do`, //获取学籍照片保存信息
        confirmStudentNewPhoto: `${prefix}/api/student/confirmStudentNewPhoto.do`, //学籍照片确认无误
        getStudentNewFaceInfo: `${prefix}/api/student/getStudentNewFaceInfo.do`, //获取新生人脸识别状态，识别过了返回1，没有则返回0
        studentNewFace: `${prefix}/api/student/studentNewFace.do`, //人脸识别，传一个image的base64
        getStudentNewDataNew: `${prefix}/api/student/getStudentNewData.do`, //获取报道材料字段以及确认状态，填写情况
        saveStudentNewData: `${prefix}/api/student/saveStudentNewData.do`, //保存报道材料
        confirmStudentNewData: `${prefix}/api/student/confirmStudentNewData.do`, //确认报到材料无误
        getRegistrationTime: `${prefix}/api/student/getRegistrationTime.do`, //获取报到时间范围
        confirmReport: `${prefix}/api/student/confirmReport.do`, //确认报到
        getReportStatus: `${prefix}/api/student/getReportStatus.do`, //获取报道状态
        getRegistrationMaterialsOpenConfig: `${prefix}/api/student/getRegistrationMaterialsOpenConfig.do`, //获取报道材料菜单是否开启（仅供非新生使用）
        getMyFinanceOpenConfig: `${prefix}/api/student/getMyFinanceOpenConfig.json`, //获取报道材料菜单是否开启（仅供非新生使用）
        getIdentityDocumentExplain: `${prefix}/api/student/getIdentityDocumentExplain.do`, //获取身份证明说明
        getStudentNewProof: `${prefix}/api/student/getStudentNewProof.do`, //获取身份证明文件列表
        saveStudentNewProof: `${prefix}/api/student/saveStudentNewProof.do`, //保存身份证明
        uploadIdentityDocument: `${prefix}/api/student/uploadIdentityDocument.do`, //上传身份证明
        getLiveDetectSessionId: `${prefix}/api/student/getLiveDetectSessionId.do`, //获取活体检测会话ID和动作代码
        liveDetect: `${prefix}/api/student/liveDetect.do`, //提交活体检测视频
        getElectiveRequire: `${prefix}/api/student/getElectiveRequire.do`, //是否完成选课
        getStudentVideoInfo: `${prefix}/api/student/getStudentVideoInfo.do`, //查询课程的已学进度
        getStudentMenuList: `${prefix}/api/student/getStudentMenuList.do`, //获取菜单信息
        getOnlineDefenseCapabilities: `${prefix}/api/student/getOnlineDefenseCapabilities.do`, //在线答辩能力
        getOnlineDefenseList: `${prefix}/api/student/getOnlineDefenseList.do`, //我的在线答辩列表
        getOnlineDefenseInfo: `${prefix}/api/student/getOnlineDefenseInfo.do`, //在线答辩详情
        uploadOnlineDefenseMaterial: `${prefix}/api/student/uploadOnlineDefenseMaterial.do`, //上传答辩资料
        deleteOnlineDefenseMaterial: `${prefix}/api/student/deleteOnlineDefenseMaterial.do`, //删除答辩资料
        getOnlineDefenseDeviceTest: `${prefix}/api/student/getOnlineDefenseDeviceTest.do`, //在线答辩设备检测
        getOnlineDefenseEntryUrl: `${prefix}/api/student/getOnlineDefenseEntryUrl.do`, //在线答辩网页入口
        listShowTemplate: `${prefix}/api/student/listShowTemplate.do`, //获取菜单信息
        getTeachingPlanCourseResourceList: `${prefix}/api/teachingPlanCourseResource/getList.do`, //根据教学计划获取资源信息
        getElectronicTextbooksList: `${prefix}/api/teachingPlanCourseResource/getElectronicTextbooksList.do`, //根据教学计划获电子教材

        getSuperintendentData: `${prefix}/api/student/getSuperintendentData.do`, //获取学生端督学提示 首页调用 隔一天调用一次
        getOpenProgressBar: `${prefix}/api/teachingPlan/getOpenProgressBar.do`, //配置是否要开启进度条 第一遍播放没有进度条，完整看完后展示进度条
        getSuperintendentPromptTime: `${prefix}/api/teachingPlan/getSuperintendentPromptTime.do`, //配置督学提示间隔时长 单位为毫秒
        getVideoCreateInfo:`https://ggk.cj-edu.com/server/api/newMoocCourse/getVideoCreateInfo.do`, //根据慕课视频id获取视频播放信息创建播放器

        creatQRCode:`${prefix}/api/studentNewData/creatQRCode.do`, //生成签名二维码
        getAttributeRelation:`${prefix}/api/student/getAttributeRelation.do`, //查询某个值的填写状态

        getStudentChangeRecordList:`${prefix}/api/student/getStudentChangeRecordList.do`, //查询学籍异动申请记录
        applyStatusChange:`${prefix}/api/student/applyStatusChange.do`, //提交申请
        getStatusChangeInfo:`${prefix}/api/student/getStatusChangeInfo.do`, //获取异动说明
        getSchoolClassValues:`${prefix}/api/student/getSchoolClassValues.do`, //班级列表
        getProfessionalValues:`${prefix}/api/student/getProfessionalValues.do`, //专业列表
        getCorrespondenceSchoolValues:`${prefix}/api/student/getCorrespondenceSchoolValues.do`, //函授站列表
        isShowStatusChange:`${prefix}/api/student/isShowStatusChange.do`, //是否显示自主异动学籍功能

        getStudentStatusPayInfo: `${prefix}/api/student/getStudentStatusPayInfo.do`, //显示缴费金额
        creatStudentStatusOrder: `${prefix}/api/student/creatStudentStatusOrder.do`, //在籍学生创建订单，获取订单outTradeNo
        getWeChatPayQRCode: `${prefix}/api/student/getWeChatPayQRCode.do`, //生成微信支付二维码
        getPayQRCode2Student: `${prefix}/api/student/getPayQRCode2Student.do`, //获取缴费二维码

        getStudentQQGroupInfo: `${prefix}/api/student/getStudentQQGroupInfo.do`, //根据correspondenceSchoolId获取QQ群信息

        getFanYuAuthUrl: `${prefix}/api/student/getFanYuAuthUrl.do`, //获取维普跳转地址


        getDegreeApplyConfig: `${prefix}/api/student/getDegreeApplyConfig.do`, //获取学生对于是否显示学位申请的配置信息
        addDegreeApplyConfig: `${prefix}/api/student/addDegreeApplyConfig.do`, //记录这次选择
        getLatestDegreeApplyRecord: `${prefix}/api/student/getLatestDegreeApplyRecord.do`, //获取学生最新的申请记录
        getDegreeApplyTemplate: `${prefix}/api/student/getDegreeApplyTemplate.do`, //获取学位模板信息，包含html和属性列表
        submitDegreeApplyRecord: `${prefix}/api/student/submitDegreeApplyRecord.do`, //提交新申请记录接口
        degreeApplyForLanguageOption: `${prefix}/api/student/degreeApplyForLanguageOption.do`, //获取外语水平认定形式下拉框
    
    
        // 专升本资格审查
        submitStudentApplyInfo: `${prefix}/api/student/studentStatusEdit.do`, //提交学生申请信息
        getStudentDataInfo: `${prefix}/api/studentStatus/getInfo.do`, //获取学生信息
    },
    /* 在线答辩 */
    ONLINE_DEFENSE: {
        capabilities: `${prefix}/api/student/getOnlineDefenseCapabilities.do`, //能力查询（功能开关）
        getDefenseList: `${prefix}/api/student/getOnlineDefenseList.do`, //我的答辩列表
        getDefenseInfo: `${prefix}/api/student/getOnlineDefenseInfo.do`, //答辩详情
        uploadMaterial: `${prefix}/api/student/uploadOnlineDefenseMaterial.do`, //上传资料
        deleteMaterial: `${prefix}/api/student/deleteOnlineDefenseMaterial.do`, //删除资料
        getDeviceTest: `${prefix}/api/student/getOnlineDefenseDeviceTest.do`, //设备检测结果
        getEntryUrl: `${prefix}/api/student/getOnlineDefenseEntryUrl.do`, //进入直播间
    },
    PAYMENT: {
        list: `${prefix}/api/student/getStudentPayInfoList.json`,//分页查询在线支付列表
        createNum:`${prefix}/jlw/pay/creatOrder.json`,//创建支付订单（新生）
        creatStudentStatusOrder:`${prefix}/api/student/creatStudentStatusOrder.do`,//创建支付订单（在籍生）
        studentPayInfo: `${prefix}/api/student/getStudentPayInfo.json`,//根据学生id查询学生时是否缴费,以及学生的基本信息
        download: `${prefix}/jlw/onlinePay/list.json`,//导出在线支付列表
        weChatPayQRCode: `${prefix}/jlw/pay/getWeChatPayQRCode.json`,//生成微信支付二维码
        aliPayQRCode: `${prefix}/jlw/pay/getAliPayQRCode.json`,//生成支付宝支付二维码
        payPrice: `${prefix}/jlw/onlinePay/getOnlinePrice.json`,//获取缴费金额
        getStudentPayList: `${prefix}/api/studentPay/getList.do`//查询缴费列表
    },
    JOINUS: {
        addMemberApply: `${prefix}/microWeb/memberApply/addMemberApply.do`,
    },
    EXTEND: {
        distributionPayApply: `${prefix}/microWeb/distribution/payApply.do`,
    },
   /*  论文 */
   THESIS:{
    getThesisRequestListByStudent:`${prefix}/api/thesisRequest/getThesisRequestListByStudent.json`,  //学生信息查询论文要求列表
    getMyApplyList:`${prefix}/api/thesisRecord/getMyApplyList.json`,  //学生信息查询论文要求列表
    getThesisCheckDetailByParam:`${prefix}/api/thesisCheck/getThesisCheckDetailByParam.json`,  //根据登录学生的信息查询学生论文所有信息（包括提交记录，审核记录）
    getEfficientThesisBatch:`${prefix}/jlw/thesisBatch/getEfficientThesisBatch.json`, //获取生效的批次信息
    getLastThesisBatchInfo:`${prefix}/api/thesisBatch/getLastThesisBatchInfo.do`, //获取最新论文批次信息（含直接提交终稿开关）
    commitChoice:`${prefix}/api/thesisCheck/commitChoice.json`, //获取生效的批次信息
    editChoice:`${prefix}/api/thesisCheck/editChoice.json`, //获取生效的批次信息
    commitProposal:`${prefix}/api/thesisCheck/commitProposal.json`, //提交开题报告
    editProposal:`${prefix}/api/thesisCheck/editProposal.json`, //提交开题报告
    commitDraft:`${prefix}/api/thesisCheck/commitDraft.json`, //提交初稿
    editDraft:`${prefix}/api/thesisCheck/editDraft.json`, //修改初稿
    commitFinal:`${prefix}/api/thesisCheck/commitFinal.json`, //提交终稿
    editFinal:`${prefix}/api/thesisCheck/editFinal.json`, //修改终稿
    directlySubmitFinalUrl:`${prefix}/api/thesisCheck/directlySubmitFinalUrl.do`, //直接提交终稿（可重复提交）
    queryStudentIsCommitThesis:`${prefix}/api/thesisStudentApply/queryStudentIsCommitThesis.json`, //查询学生是否可以提交论文
    getWeChatPayQRCodec:`${prefix}/api/thesisPlagiarismPay/getWeChatPayQRCode.json`, //生成微信二维码
    getAliPayQRCodec:`${prefix}/api/thesisPlagiarismPay/getAliPayQRCode.json`, //生成支付宝二维码
    creatOrder:`${prefix}/api/thesisPlagiarismPay/creatOrder.json`, //生成支付宝二维码
    getThesisPlagiarismPrice:`${prefix}/jlw/thesisPlagiarismPay/getThesisPlagiarismPrice.json`, //论文查重金额
    getPayDetailByOrderId:`${prefix}/api/thesisPlagiarismPay/getPayDetailByOrderId.json`,//根据订单id 查询订单信息
    commitWanXinPlagiarismCheck:`${prefix}/api/thesisPlagiarismCheck/commitWanXinPlagiarismCheck.json`,//万信提交查重
    commitWeiPuPlagiarismCheck:`${prefix}/api/thesisPlagiarismCheck/commitWeiPuPlagiarismCheck.json`,//weipu提交查重
    thesisPlagiarismCheckList:`${prefix}/api/thesisPlagiarismCheck/list.json`,//万信列表查询

    thesisBindingMaterialList:`${prefix}/api/thesisBindingMaterial/getList.do`,//胶装材料列表查询
    commitBindingMaterial:`${prefix}/api/thesisCheck/commitBindingMaterial.json`,//提交胶装材料
    editBindingMaterial:`${prefix}/api/thesisCheck/editBindingMaterial.json`,//修改胶装材料

    getDeadline:`${prefix}/api/thesisStudentApply/getDeadline.do`, //查询学生论文提交的截止日期
    huaczyUpload:`${prefix}/api/student/huaczyUpload.do`, //查询学生论文提交的截止日期
    huaczyList:`${prefix}/api/student/huaczyList.do`, //查询学生AI论文列表
   },
   /* 实习管理 */
   INTERNSHIP:{
    getInternshipInfo:`${prefix}/api/internship/getInternshipInfo.do`, //获取学生对应的实习信息
    getInternshipEvaluationFormList:`${prefix}/api/internshipEvaluationForm/getInternshipEvaluationFormList.do`, //获取实习鉴定表提交记录列表
    submitInternshipEvaluationForm:`${prefix}/api/internshipEvaluationForm/submitInternshipEvaluationForm.do`, //提交实习鉴定表
   },

   /* 重修申请 */
   COURSE_RETAKE:{
    canApply:`${prefix}/api/student/courseRetake/canApply.do`, //是否可申请重修
    currentSetting:`${prefix}/api/student/courseRetake/currentSetting.do`, //获取当前可申请批次
    courses:`${prefix}/api/student/courseRetake/courses.do`, //获取可选教学计划课程
    apply:`${prefix}/api/student/courseRetake/apply.do`, //提交重修申请
    list:`${prefix}/api/student/courseRetake/list.do`, //我的重修申请列表
    detail:`${prefix}/api/student/courseRetake/detail.do`, //我的重修申请详情
   }

};

export default jwlApis;



// WEBPACK FOOTER //
// ./src/common/serverApi.js